export default "//static.tradera.net/touchweb/static/output/images/maestro_vertical.ea69c057.svg";